module.exports = __webpack_public_path__ + "img/opera360_api.a6037f9e.png";